import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      navigationDrawerEnabled: true,
      lastUser: null
    }
  },
  computed: {
    currentNavItem () {
      return this.navItemMap[this.$route.path]
    },
    ...mapGetters({
      coreMenuItems: 'menuItems',
      navItems: 'navItems',
      navItemMap: 'navItemMap'
    }),
    routeTitle () {
      const currentNavItem = this.currentNavItem
      return currentNavItem ? currentNavItem.title : this.$route.name
    },
    routeContextMenu () {
      const currentNavItem = this.currentNavItem
      if (currentNavItem && currentNavItem.meta && currentNavItem.meta.contextMenu) {
        return currentNavItem.meta.contextMenu(this)
      }
    },
    availableRootMenuItems () {
      return this.navItems.filter(n => n.show)
    },
    activeRootMenuItem () {
      return this.availableRootMenuItems.find(n => {
        return this.findActiveNavItemAndDepth(n, this.$route.path).depth
      })
    },
    hasActiveSubMenus () {
      const activeRootMenuItem = this.activeRootMenuItem
      return activeRootMenuItem && activeRootMenuItem.hasSub
    }
  },
  methods: {
    ...mapActions({
      buildNavItems: 'buildNavItems',
      updateNavItems: 'updateNavItems'
    }),
    setNavItems () {
      const _this = this
      this.buildNavItems(_this)
    },
    findActiveNavItem (item, currentPath) {
      const activeNavVal = this.findActiveNavItemAndDepth(item, currentPath)
      return activeNavVal ? activeNavVal.item : false
    },
    findActiveNavItemAndDepth (item, currentPath, depth) {
      depth = depth || 1
      if (item.to === currentPath) return {
        item: item,
        depth: depth
      }
      for (const childItem of item.items) {
        const childVal = this.findActiveNavItemAndDepth(childItem, currentPath, depth + 1)
        if (childVal.item) return childVal
      }
      return {
        item: false,
        depth: false
      }
    },
    runNavItemUpdaters () {
      console.warn('runNavItemUpdaters', this)
      const _this = this
      this.updateNavItems(_this)
    },
    checkPageAccess () {
      if (!this.$ftUser.username) {
        console.warn("Can't check page access -- user not loaded!")
        return // user object may not be loaded yet
      }
      const navItem = this.navItemMap[this.$route.path]
      if (!navItem) {
        console.warn('Can\'t check page access.  Nav item for path does not exist.', this.$route.path)
        return
      }
      if (!navItem.access(this)) {
        if (this.lastUser && this.lastUser !== this.$ftUser.username) {
          console.warn('Access denied for user change - redirecting to default!', navItem, this.$route.path)
          this.$router.replace('/')
        } else {
          console.warn('Access denied - redirecting!', navItem, this.$route.path)
          this.$router.replace('/no-access')
        }
      }
      this.lastUser = this.$ftUser.username
    },
    doNavRoute (navItem) {
      if (navItem.linkAction) {
        navItem.linkAction(this)
      } else {
        this.$router.push(navItem.to)
      }
    }
  }
}
